// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyD5MNdVnMqQEmGJI7DRaXZ2gQaxaEtKeIs",
    authDomain: "shellhero.firebaseapp.com",
    projectId: "shellhero",
    storageBucket: "shellhero.appspot.com",
    messagingSenderId: "253163839005",
    appId: "1:253163839005:web:2d322fa8951b6a63b3f0f4",
    measurementId: "G-SH7RQXN6Z2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export default app;
